module.exports = __webpack_public_path__ + "img/oreilly.e28fd8ec.jpg";